export default __webpack_public_path__ + "static/media/textus.95c016b7.svg";